var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_vm._v(" test "),_c('c-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }